import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { isNative } from '../utils/platform';

export function useStatusBar(darkMode) {
  useEffect(() => {
    if (!isNative()) return;
    let cancelled = false;

    (async () => {
      const { StatusBar, Style } = await import('@capacitor/status-bar');
      if (cancelled) return;
      try {
        await StatusBar.setStyle({ style: darkMode ? Style.Light : Style.Dark });
        // Android 15 (SDK 35) enforces edge-to-edge; setBackgroundColor is a
        // deprecated no-op on transparent system bars. Overlay the WebView so
        // env(safe-area-inset-*) populates consistently across SDK levels and
        // our existing .safe-top / .safe-bottom utilities handle insets.
        if (Capacitor.getPlatform() === 'android') {
          await StatusBar.setOverlaysWebView({ overlay: true });
        }
      } catch (err) {
        console.warn('StatusBar setup failed:', err);
      }
    })();

    return () => { cancelled = true; };
  }, [darkMode]);
}
